/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';
import { ReleaseAccessListOperationEnum } from './releaseAccessListOperationEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsPersonaEnum } from './vcdsPersonaEnum';
import { ReleaseTypeEnum } from './releaseTypeEnum';


export interface UpdateReleaseAccessListSpec { 
    /**
     * Version String for a release
     */
    version: string;
    service_type: ServiceTypeEnum;
    release_type: ReleaseTypeEnum;
    cloud_provider?: CloudProviderEnum;
    persona?: VcdsPersonaEnum;
    operation: ReleaseAccessListOperationEnum;
    /**
     * List of org ids having access to release
     */
    access_list: Array<string>;
}
export namespace UpdateReleaseAccessListSpec {
}


